import React from 'react';
import { useSelector } from 'react-redux';
import EventList from './EventList';

const MyEvent = () => {
  const studentEvent = useSelector((state) => state.student_event);
  const blankBg = () => {
    if (studentEvent !== null) {
      if (!studentEvent[0]) {
        return 'list-background-events';
      }
    } else {
      return 'list-background-course-empty';
    }
  };

  return (
    <>
      <div className={blankBg()}>
        {studentEvent ? studentEvent.map((el) => <EventList event={el} />) : ''}
      </div>
    </>
  );
};

export default MyEvent;
